module.exports = "<exa-weather-kwh-heatmap-section [customer]=\"customer.selected$ | async\"></exa-weather-kwh-heatmap-section>\r\n"